import { css } from '@emotion/react';

import { useCallback, useState } from 'react';

import Button from 'components/field/Button';
import ConfirmationDialog from 'components/global/ConfirmationDialog';

import { faTrashCan } from '@fortawesome/pro-regular-svg-icons';
import { faCheck, faTimes } from '@fortawesome/pro-solid-svg-icons';

const DeleteButton = ({ row, setEditing, onRowDelete, disabled }) => {
	const [deleteButtonRef, setDeleteButtonRef] = useState(null);

	const handleDeleteButtonClick = useCallback(async () => {
		onRowDelete && (await onRowDelete(row));
		setEditing((prev) => prev.filter((obj) => obj !== row.index).map((obj) => (obj > row.index ? obj - 1 : obj)));
	}, [row, setEditing, onRowDelete]);

	return (
		<>
			<Button
				ref={setDeleteButtonRef}
				icon={faTrashCan}
				disabled={disabled}
				color="var(--red)"
				variant="transparent"
				css={css`
					border-color: var(--red) !important;
				`}
			/>
			{!disabled && (
				<ConfirmationDialog
					buttonRef={deleteButtonRef}
					placement="bottom-end"
					title="confirmation.deleteItem"
					icon={faTrashCan}
					leftIcon={faTimes}
					rightLabel="yes"
					leftLabel="cancel"
					rightIcon={faCheck}
					rightAction={handleDeleteButtonClick}
				/>
			)}
		</>
	);
};

export default DeleteButton;
